import { selectFilterId } from '../selectors';
import * as types from '../types';

function setAllowNearbyActive(isActive, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_setAllowNearbyActive(filterId, isActive));
    };
}

function _setAllowNearbyActive(filterId, isActive) {
    return {
        meta: filterId,
        payload: isActive,
        type: types.SET_ALLOW_NEARBY_ACTIVE,
    };
}

function resetAllowNearby(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_resetAllowNearby(filterId));
    };
}

function _resetAllowNearby(filterId) {
    return {
        meta: filterId,
        type: types.RESET_ALLOW_NEARBY,
    };
}

export {
    resetAllowNearby,
    setAllowNearbyActive,
};
